import { type HTMLAttributes, type ReactNode } from 'react';
import styles from './card.module.css';

/*
 * `warm` TONU KALKTI (yeni görünüm 1c, 1b tech-lead devri): 1b'de `surface`
 * okumaya geçmişti ve depoda kullanan yoktu; panel çalışma alanı `surface`
 * zemine geçince kart zeminde görünmez olurdu. Sessiz bilgi bloğu için kitte
 * InlineAlert `--quiet` var.
 */
export type CardTone = 'default' | 'warm2' | 'raised';

export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  /** Kartın üst etiketi; cümle düzeninde, büyük harf yok (`label` stili). */
  readonly kicker?: string;
  readonly title?: ReactNode;
  readonly meta?: ReactNode;
  readonly tone?: CardTone;
  readonly accentTop?: boolean;
}

/**
 * Kart (InfoCard kartı, `wb-card`): kart yüzeyi, 1 px kenarlık, `radius-card`
 * (16 px), `shadow-1`, `space-6` iç boşluk. `tone` yüzey ailesini, `accentTop`
 * öne çıkan kart desenini (petrol kenarlık + `shadow-2`) seçer.
 */
export function Card({
  kicker,
  title,
  meta,
  tone = 'default',
  accentTop = false,
  className,
  children,
  ...rest
}: CardProps) {
  const toneClass = tone === 'warm2' ? styles.warm2 : tone === 'raised' ? styles.raised : '';
  return (
    <div
      {...rest}
      className={[styles.card, toneClass, accentTop ? styles.accentTop : '', className ?? '']
        .filter(Boolean)
        .join(' ')}
    >
      {kicker ? <p className={styles.kicker}>{kicker}</p> : null}
      {title ? <p className={styles.title}>{title}</p> : null}
      {meta ? <p className={styles.meta}>{meta}</p> : null}
      {children}
    </div>
  );
}

export const cardStyles = styles;
